<template>
  <div class="range">
    <div class="header">
        <img src="../images/banner.png" alt="" width="100%" style="margin-bottom:15px;">
    </div>
    <p class="doc_title">WiFi万能钥匙用户安全理赔计划</p>
    <p class="doc_text">WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。</p>
     <p class="doc_title">WiFi万能钥匙商户热点安全理赔计划</p>
    <p class="doc_text">WiFi万能钥匙热点商户联盟安全理赔计划是指商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本保险计划的有关规则申请理赔。</p>

    <p class="doc_title">提供保障</p>
    <p class="doc_text">每人单日/单次最高赔付20000元<br>每人累计最高赔付100000元</p>

    <p class="doc_title">重要提示</p>
    <p class="doc_text">1.用户（含商户赖以执行参保的设备持有者）必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。</p>
    <p class="doc_text">2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。</p>
  </div>
</template>

<script>
export default {
  name: 'newrangePersonal',
  mounted:function(){
    // Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_detail'
    //     }
    // });
    this.$trace.enterTraceDone({ page: 10,  type: 'rangePersonal'})
  }
}
</script>

<style scoped>
.doc_title{margin-top: 0;margin-bottom: 10px;padding-top: 0;}
</style>



// WEBPACK FOOTER //
// rangePersonal.vue?401ce253